export const formatHours = (value, digits = 1) => {
    const num = Number(value)
    if (!Number.isFinite(num)) return '0'
    return num.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
    })
}

export const getUtilizationPercent = (logged, estimated) => {
    const est = Number(estimated)
    const log = Number(logged)
    if (!Number.isFinite(est) || est <= 0) {
        if (!Number.isFinite(log) || log <= 0) return 0
        return 100
    }
    return Math.round((log / est) * 100)
}

export const getUtilizationTone = (percent) => {
    if (percent <= 85) return 'good'
    if (percent <= 110) return 'warn'
    return 'over'
}

export const getInitials = (name) => {
    if (!name) return 'U'
    const parts = String(name).trim().split(/\s+/).filter(Boolean)
    if (parts.length >= 2) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
    }
    return String(name).slice(0, 2).toUpperCase()
}
